module.exports = __webpack_public_path__ + "img/icon_report_on.1ad681a9.svg";